import axios from 'axios'
import Cookie from 'js-cookie'
import CookieUtil from '../utils/cookieUtil'
// import store from '../store/index'
import Vue from 'vue'
import router from '../router/index'
// import {Loading, Notification, Message} from 'element-ui'
import {Loading, Message} from 'element-ui'
let loadingInstance
// Vue.use(iView)
// axios 配置  timeout单位为毫秒
// var timeOut = 1000 * 60 * 30
var timeOut = 0
let loadingCount = 0
axios.defaults.timeout = timeOut
let API_HOST = process.env.API_HOST + '/api'
axios.defaults.headers = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Authorization': 'MerckAuthentication ' + Cookie.get('token'),
  'route': ''
}
// axios.defaults.transformRequest = [function (data, config) {
//   if (config['Content-Type'] === 'multipart/form-data') {
//     return data
//   }
// }]
// axios.defaults.transformRequest = [function (data) {
//   data = Qs.stringify(data)
//   return data
// }]
// axios.defaults.withCredentials = true

// http request 拦截器
// var num = 0
axios.interceptors.request.use(
  config => {
    config.baseURL = API_HOST
    loadingCount++
    // num++
    // if (localStorage.demoSpinIconLoad !== 'demoSpinIconLoad') {
    //   // Vue.prototype.$Spin.show({
    //   //   render: (h) => {
    //   //     return h('div', [
    //   //       h('Icon', {
    //   //         'class': 'demo-spin-icon-load',
    //   //         props: {
    //   //           type: 'load-a',
    //   //           size: 36
    //   //         }
    //   //       })
    //   //     ])
    //   //   }
    //   // })
    //   // localStorage.demoSpinIconLoad = ''
    // if (loadingCount === 1) {
    // loadingInstance = Loading.service({background: 'transparent'})
    // }

    if (config.hideLoader !== true) {
      loadingInstance = Loading.service({background: 'transparent'})
    }

    // } else {
    //   localStorage.demoSpinIconLoad = ''
    // }
    if (localStorage.token) {
      config.headers.Authorization = 'MerckAuthentication ' + Cookie.get('token')
      config.headers['Accept-Language'] = Cookie.get('currentLanguage') === null ? 'zh-CN' : Cookie.get('currentLanguage') === 'mergeZH' ? 'zh-CN' : 'en-US'
      config.headers['route'] = Cookie.get('route')
    }
    if (config['headers']['Content-Type'] === 'multipart/form-data') {
      return config
    } else {
      config.data = JSON.stringify(config.data)
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
// http response 拦截器
axios.interceptors.response.use(
  response => {
    // num--
    loadingCount--
    // if (num <= 0) {
    if (loadingCount <= 0 && response.config.hideLoader !== true) {
      loadingInstance.close()
    } else {
      // loadingInstance = Loading.service({})
    }
    if (response.status === 204) {

    } else {
      return response
    }
  },
  error => {
    loadingCount--
    if (loadingCount <= 0 && error.response.config.hideLoader !== true) {
      loadingInstance.close()
    }
    if (error.response) {
      switch (error.response.status) {
        case 500:
          if (error.response.data) {
            // let duration = 5
            if (error.response.config.responseType === 'arraybuffer') {
              let unit8Arr = new Uint8Array(error.response.data)
              let encodedString = String.fromCharCode.apply(null, unit8Arr)
              let decodedString = decodeURIComponent(escape((encodedString)))
              // Notification.error({
              //   title: '失败',
              //   message: JSON.parse(JSON.parse(decodedString)).Message
              // })
              Message.error(JSON.parse(JSON.parse(decodedString)).Message)
            } else {
              if (JSON.parse(error.response.data).Message.length > 20) {
                // duration = 8
              }
              // Notification.error({
              //   title: '失败',
              //   message: JSON.parse(error.response.data).Message
              // })
              Message.error(JSON.parse(error.response.data).Message)
            }
          } else {
            // Notification.error({
            //   title: '失败',
            //   message: '请求服务器被拒绝，请清空浏览器缓存后重试'
            // })
            Message.error('请求服务器被拒绝，请清空浏览器缓存后重试')
          }
          break
        case 400:
          if (error.response.data) {
            // let duration = 5
            if (error.response.config.responseType === 'arraybuffer') {
              let unit8Arr = new Uint8Array(error.response.data)
              let encodedString = String.fromCharCode.apply(null, unit8Arr)
              let decodedString = decodeURIComponent(escape((encodedString)))
              Vue.prototype.$Message.error({
                content: JSON.parse(JSON.parse(decodedString)).Message,
                duration: 5
              })
            } else {
              if (JSON.parse(error.response.data).Message.length > 20) {
                // duration = 8
              }
              // Notification.error({
              //   title: '失败',
              //   message: JSON.parse(error.response.data).Message
              // })
              Message.error(JSON.parse(error.response.data).Message)
            }
          } else {
            // Notification.error({
            //   title: '失败',
            //   message: '当前操作引发未知错误，请联系管理员'
            // })
            Message.error('当前操作引发未知错误，请联系管理员')
          }
          break
        case 401:
          router.push('/')
          CookieUtil.clear()
          // Notification.error({
          //   title: '失败',
          //   message: '没有权限访问'
          // })
          break
        case 404:
          // router.push('/404')
          break
        case 405:
          router.push('/index')
          CookieUtil.clear()
          // Notification.error({
          //   title: '失败',
          //   message: '没有权限访问'
          // })
          break
        default:
          router.push('/index')
          CookieUtil.clear()
          // Notification.error({
          //   title: '失败',
          //   message: '没有权限访问'
          // })
          break
      }
    } else {
      router.push('/index')
      CookieUtil.clear()
      // Notification.error({
      //   title: '失败',
      //   message: '没有权限访问'
      // })
    }
    return Promise.reject(error)
  }
)
export default axios



// WEBPACK FOOTER //
// ./src/utils/axios.js